<template>
    <button
        @click.prevent="$emit('on-click')"
        :class="[buttonColor, buttonAlignment]"
        class="flex text-lg items-center justify-center w-8 h-8 absolute">
        <IconXmark class="inline" />
    </button>
</template>

<script>
    import IconXmark from "@/atoms/icons/IconXmark"

    export default {
        name: 'XButton',
        components: {
            IconXmark
        },
        props: {
            color: {
                type: String,
                default: 'default',
                validator: (val) => ['default', 'light'].includes(val),
            },
            alignment: {
                type: String,
                default: 'default',
                validator: (val) => ['default', 'tight'].includes(val),
            },
        },
        computed: {
            buttonColor() {
                return {
                    default: `top-8 right-8 text-navy-dark`,
                    light: `text-gray-900 top-8 right-8 text-2xl`,
                }[this.color]
            },
            buttonAlignment() {
                return {
                    default: `transform translate-x-1/2 -translate-y-1/2`,
                    tight: `transform translate-x-1/2 -translate-y-1/4 desktop:-translate-y-1/2`,
                }[this.alignment]
            },
        }
    }
</script>
